import { Box, Typography } from '@mui/material';
import React from 'react';

interface InfoMProps {
  label: React.ReactNode;
  children: React.ReactNode;
}

export function InfoM({ label, children }: InfoMProps) {
  return (
    <Box mb={2}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 400,
          textTransform: 'uppercase',
          fontSize: '0.8rem',
          marginBottom: '0.3rem',
          color: '#848d95', // More accurate gray color matching the original
          display: 'block',
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        component="div"
        sx={{
          fontSize: '1rem',
          color: 'text.primary',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}
